// Structured context for the "Unconfirmed actions are older than 5 seconds"
// Sentry canary. The pending-edit queue is shared by every tab of a round,
// so one stuck edit fires the canary in each open tab; all tabs compute the
// same incident_key from the shared queue, so grouping events by that tag
// collapses a multi-tab burst into its real incidents.

export function buildSyncCanaryIncidentKey(
  roundId: string,
  oldestCreatedAt: number,
): string {
  return `${roundId}:${oldestCreatedAt}`;
}

export type SyncCanaryDiagnostics = {
  unconfirmedCount: number;
  oldestAgeMs: number | null;
  queuedActionTypes: string[];
  socketStatus: string;
};

export function buildSyncCanaryDiagnostics(input: {
  unconfirmedActions: {
    createdAt: number;
    message: { id: string; payload: { type: string } };
  }[];
  socketStatus: "connected" | { reason: string } | null;
  now: number;
}): SyncCanaryDiagnostics {
  const { unconfirmedActions, socketStatus, now } = input;
  const oldest = unconfirmedActions[0];
  return {
    unconfirmedCount: unconfirmedActions.length,
    oldestAgeMs: oldest ? now - oldest.createdAt : null,
    queuedActionTypes: [
      ...new Set(unconfirmedActions.map((a) => a.message.payload.type)),
    ].sort(),
    socketStatus:
      socketStatus == null
        ? "unknown"
        : socketStatus === "connected"
          ? "connected"
          : `disconnected: ${socketStatus.reason}`,
  };
}
